import React, { FC } from "react";
import {
  SuccessMessageContainer,
  Title,
  Subtitle,
  LogoWrapper,
  TrianglesWrapper,
  VectorSVGs
} from "../ReportTheftSuccessSection/ReportTheftSuccessSection.styled";
import { AllsetraTriangles, PlusTwo } from "assets/icons";

const ReportTheftNewSuccessSection: FC = () => {
  return (
    <React.Fragment>
      <VectorSVGs>
        <PlusTwo style={{ position: "absolute", right: 0, top: "25vh" }} />
      </VectorSVGs>

      <LogoWrapper>
        <TrianglesWrapper>
          <AllsetraTriangles />
        </TrianglesWrapper>
      </LogoWrapper>

      <SuccessMessageContainer>
        <Title>Je account is succesvol aangemaakt</Title>
        <Subtitle>
          Bedankt voor het aanmaken van je persoonlijke account. Je ontvangt zo
          direct een e-mail met je inloggegevens en verdere instructies om je
          diefstalmelding te starten.
        </Subtitle>
      </SuccessMessageContainer>
    </React.Fragment>
  );
};

export default ReportTheftNewSuccessSection;
